import React, {useEffect, useState} from 'react';
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {toggleProductNoteEditorVisible} from "../../../actions/selectionFunctions";
import {togglePulseFeatureInfoNote} from "../../../actions/actionFunctions";

const AddProductNoteEditor = (props) => {

  const {selectionFeatureInfo, productNoteEditorVisible, intl, toggleProductNoteEditorVisible, activeQuoteIndex,
    pulseFeatureInfoNote, togglePulseFeatureInfoNote} = props;
  const [noteText, setNoteText] = useState("");

  useEffect(() => {
    setNoteText(selectionFeatureInfo?.notesList[activeQuoteIndex] || "");
  }, [selectionFeatureInfo, activeQuoteIndex]);

  const onNoteChange = (e) => {
    setNoteText(e.target.value);
    if (pulseFeatureInfoNote) {
      togglePulseFeatureInfoNote(false);
    }
  };

  const onNoteSaveClick = () => {
    selectionFeatureInfo.notesList[activeQuoteIndex] = noteText;
    toggleProductNoteEditorVisible(false);
  };

  return (
    <div className={"product-note" + (productNoteEditorVisible ? " product-note--active" : "")
      + (pulseFeatureInfoNote ? " ui-quantity--pulsing-red" : "")}>
      <textarea name=""
                id=""
                cols="30"
                rows="10"
                className="product-note__textarea ui-textarea"
                placeholder={intl.formatMessage({id: "quotingTool.featureInfo.addNoteButton"})}
                value={noteText}
                onChange={onNoteChange} />
      <button className="product-note__button ui-button2 ui-button2--green" onClick={onNoteSaveClick}>
        <FormattedMessage id="quotingTool.featureInfo.saveNoteButton"/>
      </button>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {selectionFeatureInfo, productNoteEditorVisible, pulseFeatureInfoNote} = store.selectionState;
  return {
    selectionFeatureInfo,
    productNoteEditorVisible,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    pulseFeatureInfoNote,
  };
};

const mapDispatchToProps = {
  toggleProductNoteEditorVisible,
  togglePulseFeatureInfoNote,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AddProductNoteEditor)
);
